<template>
  <div>
    <v-flex ml-3>
      <v-avatar :size="avatarSize" color="white">
        <v-img
          v-if="avatar"
          :src="avatar"
          alt="avatar"
          aspect-ratio="1"
          style="border-radius: 12px"
          contain
        ></v-img>
        <v-icon :size="avatarSize" v-if="!avatar">fa-shield-alt</v-icon>
      </v-avatar>
    </v-flex>
    <v-card-title primary-title v-if="showName">
      <h3>{{name}}</h3>
    </v-card-title>
  </div>
</template>
<script>
export default {
  props: {
    avatar: {
      type: String
    },
    name: {
      type: String
    },
    showName: {
      type: Boolean,
      default: false
    },
    avatarSize: {
      type: Number,
      default: 50
    }
  }
};
</script>